import { FileText, Check } from "lucide-react";
import ReCAPTCHA from "react-google-recaptcha";
import { FormTextarea, CheckboxGroup } from "./FormInput";

const CONTACT_METHODS = ['Phone Call', 'Text Message', 'Email'];
const CONTACT_TIMES = ['Morning', 'Afternoon', 'Evening', 'Anytime'];

const FinalDetailsStep = ({ 
  formData, 
  onChange, 
  onCheckboxChange,
  onConsentToggle,
  recaptchaRef,
  recaptchaSiteKey,
  onRecaptchaChange 
}) => {
  return (
    <div className="space-y-6 animate-fade-in" data-testid="final-details-step">
      <h2 className="text-xl font-bold text-white flex items-center gap-2">
        <FileText className="w-5 h-5 text-[#D4AF37]" />
        Final Details
      </h2>
      
      <div className="space-y-4">
        <div>
          <FormTextarea
            label="Is there anything else you'd like us to know?"
            required
            name="additional_info"
            value={formData.additional_info}
            onChange={onChange}
            placeholder="If there is nothing else to add, please type 'No'."
            rows={4}
          />
          <p className="text-xs text-[#666] mt-1">
            If you have nothing additional to add, please enter &apos;No&apos; to continue.
          </p>
        </div>

        <CheckboxGroup
          label="Preferred contact method (Select all that apply)"
          name="preferred_contact"
          options={CONTACT_METHODS}
          selected={formData.preferred_contact}
          onChange={onCheckboxChange}
          required
          columns={3}
        />

        <CheckboxGroup
          label="Best time to contact (Select all that apply)"
          name="best_time_to_contact"
          options={CONTACT_TIMES}
          selected={formData.best_time_to_contact}
          onChange={onCheckboxChange}
          required
          columns={4}
        />

        <div className="bg-[#0A0A0A] p-4 border border-white/10">
          <label className="flex items-start gap-3 cursor-pointer">
            <div 
              className={`w-5 h-5 mt-0.5 border flex items-center justify-center flex-shrink-0 ${
                formData.consent_given 
                  ? 'border-[#D4AF37] bg-[#D4AF37]' 
                  : 'border-white/30'
              }`}
              onClick={onConsentToggle}
            >
              {formData.consent_given && <Check className="w-4 h-4 text-black" />}
            </div>
            <span className="text-sm text-[#A3A3A3]">
              I agree to be contacted by phone, email, and SMS regarding my property inquiry. Message and data rates may apply. *
            </span>
          </label>
        </div>

        <div className="flex justify-center" data-testid="recaptcha-container">
          <ReCAPTCHA
            ref={recaptchaRef}
            sitekey={recaptchaSiteKey}
            onChange={onRecaptchaChange}
            theme="dark"
          />
        </div>
      </div>
    </div>
  );
};

export default FinalDetailsStep;
